export default {
    new: $localize `New`,
    pending: $localize `Pending`,
    in_progress: $localize `In progress`,
    on_hold: $localize `On hold`,
    completed: $localize `Completed`,
    cancelled: $localize `Cancelled`,
}
